import React, { useContext, useEffect, useRef, useState } from "react";
import { baseRequest } from "../../../axiosconfig";
import { formatListToMap } from "../../../utils/formatters";
import { ROLES } from "../../../constants/roles";
import { hasUnitEditPermission } from "../../../utils/permissions";
import "./singlemapaprocesa.css";
import DropdownWrapper from "../../elements/dropdownWrapper";
import DropDown from "../../elements/dropDown";
import CenterDropdownWrapper from "../../elements/CenterDropdownWrapper";
import DynamicTextarea from "../../elements/DynamicTextarea";
import MapeProcesaAktivnostiList from "../../mapeProcesaAktovnostiList";

import PoslovniProcessOwnerTable from "../../poslovniProcesiOwnerTable";
import MapeDokumentacija from "../../mapeDokumentacija";
import ProcedureDocumentation from "../../procedureDocumentation";
import Loading from "../../loading";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import ProcedureList from "../../procedureList";
import NewProcedura from "../../newProcedura";
import NewProcedureRow from "../../newProcedureRow";
import { v4 as uuidv4 } from "uuid";
import DeleteMapaPopup from "../../deleteMapaPopup";
import RiskList from "../RiskList";
import NewRisk from "../NewRisk";
import { UserContext } from "../../../userContext";
import { UnsavedDataContext } from "../../../context";
import { cleanDocuments } from "../../../utils/documentLinks";
import {
  uploadActivityDocument,
  uploadErrorMessage,
  validateFileLocally,
} from "../../../utils/activityDocuments";
import { validateProcedureRow } from "../../../utils/flowValidation";
import MapaProcesaPrint from "./printMapaProcesa";
import { useReactToPrint } from "react-to-print";
import { PRINT_PAGE_STYLE } from "../../../utils/printPageStyle";
import { useClickOutside } from "../../../hooks";
import VersionHistory from "../versionHistory";
import { downloadFile } from "../../../utils/download";

export function formatDesignations(list) {
  return list.map((item) => {
    return {
      id: item.id,
      first_name: item.first_name,
      last_name: item.last_name,
      name: item.designation
        ? `${item.first_name} ${item.last_name} - ${item.designation.name}`
        : item.designation_name
        ? `${item.first_name} ${item.last_name} - ${item.designation_name}`
        : `${item.first_name} ${item.last_name}`,
      designation_name: item.designation
        ? item.designation.name
        : item.designation_name || "",
    };
  });
}

export function formatProcesses(list) {
  const newList = [];

  list.forEach((item) => {
    if (!item.del)
      item.business_process_lists.forEach((element) => {
        if (!element.del)
          newList.push({
            ...element,
            org_unit: `${item.organization_unit_id}${item.level}`,
            organization_unit_id: item.organization_unit_id,
            level: item.level,
            org_unit_name: item.name,
            manager_employee_id: item.manager_employee_id,
            manager: item.employee,
          });
      });
  });

  return newList;
}

export default function SingleMapeProcesa() {
  const [processes, setProcesses] = useState([]);
  const [organization_units, setOrganization_units] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [designationsList, setDesignationsList] = useState();
  const [loading, setLoading] = useState(false);
  const [mapa, setMapa] = useState();
  const [mapaList, setMapaList] = useState({});
  const [newActivity, setNewActivity] = useState();
  const [newRisk, setNewRisk] = useState();
  const [activeRisk, setActiveRisk] = useState();
  const [newProcedure, setNewProcedure] = useState();
  const [newProcedureRow, setNewProcedureRow] = useState();
  const [activeProcedure, setActiveProcedure] = useState();
  // Spisak praznih opcionih polja posle uspešnog čuvanja (informacija, ne greška)
  const [savedEmptyFields, setSavedEmptyFields] = useState(null);
  const [newActivityValidationErrors, setNewActivityValidationErrors] =
    useState();
  const [newProcedureValidationErrors, setNewProcedureValidationErrors] =
    useState();
  const [newProcedureRowValidationsError, setNewProcedureRowValidationsError] =
    useState();
  const [oldProcedureRowValidationsError, setOldProcedureRowValidationsError] =
    useState();
  const [mapaToDelete, setMapaToDelete] = useState();
  const [activityToDelete, setActivityToDelete] = useState();
  const [procedureToDelete, setProcedureToDelete] = useState();
  const [riskToDelete, setRiskToDelete] = useState();
  const [riskForms, setRiskForms] = useState();
  const [showDropdown, setShowDropdown] = useState(false);

  const [newRiskValidationError, setNewRiskValidationerror] = useState();
  const [riskValidationError, setRiskValidationError] = useState();
  const [errorMessages, setErrorMessages] = useState();
  const [rawMapas, setRawMapas] = useState();
  const [showVersionHistory, setShowVersionHistory] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { user } = useContext(UserContext);
  const { setUnsavedData } = useContext(UnsavedDataContext);
  const componentRef = useRef();
  const dropdownRef = useRef();

  // Napuštanje strane briše oznaku nesačuvanih izmena
  useEffect(() => {
    return () => setUnsavedData(false);
  }, [setUnsavedData]);

  useClickOutside(dropdownRef, () => {
    setShowDropdown(false);
  });

  const wrapperStyle = { borderBottom: "none" };
  const wrapperTitleStyle = { borderRight: "1px solid var(--mainColor)" };

  // Polja mape koja smeju ostati prazna (ID 6) — posle čuvanja se samo navode
  const optionalMapFields = [
    { key: "process_goal", label: "CILJ PROCESA" },
    { key: "description_input", label: "ULAZ" },
    { key: "description_action", label: "AKTIVNOSTI" },
    { key: "description_output", label: "IZLAZ" },
  ];

  const calculateProcess = (id, list) => {
    return list.find((proc) => {
      return proc.id === id;
    });
  };

  const calculateUnitProcesses = (id, level, list, mapas) => {
    const unitProcesses = list.filter((item) => {
      return (
        item.organization_unit_id === id && item.level === level && !item.del
      );
    });

    const formattedProcesses = unitProcesses.map((pr) => {
      const match = mapas.find((mapa) => {
        return (
          !mapa.del &&
          !mapa.is_archived &&
          mapa?.business_process_list?.id &&
          mapa.business_process_list.id === pr.id
        );
      });
      if (match) {
        return { ...pr, isDisabled: true };
      } else {
        return { ...pr, isDisabled: undefined };
      }
    });

    return formattedProcesses;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: PRINT_PAGE_STYLE,
  });

  useEffect(() => {
    setLoading(true);
    const urls = [
      "/organization_unit/0",
      "/employee/id/0/level/0",
      "/designations/0/0",
      "/business_processes",
      "/process_maps",
    ];

    Promise.all(
      urls.map((url) => baseRequest.get(url))
    )
      .then((res) => {
        const [unitsRes, employeesRes, designationsRes, processesRes, mapsRes] =
          res;
        const responseObj = {
          organization_units: unitsRes.data.data || [],
          designations: formatDesignations(employeesRes.data.data || []),
          designationsList: designationsRes.data.designations || [],
          business_processes: processesRes.data.business_processes || [],
          process_maps: mapsRes.data.process_maps || [],
        };

        const orgUnits = responseObj["business_processes"]
          .map((process) => {
            if (
              process.level >= 0 &&
              !process.del &&
              process.business_process_lists.length > 0 &&
              process.business_process_lists.some((pr) => !pr.del)
            ) {
              return {
                id: process.organization_unit_id,
                name: process.name,
                level: process.level,
              };
            } else {
              return undefined;
            }
          })
          .filter((item) => item)
          .map((item) => {
            const unit = responseObj["organization_units"].find(
              (unit) =>
                unit.id === item.id && unit.level === item.level && !unit.del
            );
            return unit;
          })
          // Lista obrisane jedinice nema par među živim jedinicama; prazna
          // stavka bi srušila birač jedinice (čita unit.id)
          .filter(Boolean);

        setOrganization_units(orgUnits);
        setDesignations(responseObj["designations"]);
        setProcesses(formatProcesses(responseObj["business_processes"]));
        setDesignationsList(responseObj["designationsList"]);
        // const actualMapas = responseObj["process_maps"].filter(
        //   (mapa) => mapa.business_process_list_id !== null
        // );

        const mapasWithProcess = responseObj["process_maps"].map((mapa) => {
          return {
            ...mapa,
            process: mapa.business_process_list_id
              ? calculateProcess(
                  mapa.business_process_list_id,
                  formatProcesses(responseObj["business_processes"])
                )
              : {},
          };
        });

        setMapaList(formatListToMap(mapasWithProcess));
        setRawMapas(mapasWithProcess);

        const firstMapa = mapasWithProcess[0];
        if (params.id === "new") {
          // Nova mapa je samo lokalno stanje dok se ne sačuva (QA-02);
          // naziv organizacije se predlaže kao i do sada (naziv Uprave)
          const administration = responseObj["organization_units"].find(
            (unit) => unit.level === 0
          );
          setMapa({
            adding: true,
            activities: [],
            procedures: [],
            risk_forms: [],
            process: {},
            company_name: administration?.name || "",
          });
        } else if (params.id) {
          const mapa = formatListToMap(mapasWithProcess)[params.id];

          // Obrisana ili nepostojeća mapa (npr. "Nazad" posle brisanja):
          // vrati korisnika na listu umesto praznog ekrana
          if (!mapa || mapa.del) {
            setLoading(false);
            navigate("/admin/mape-procesa", { replace: true });
            return;
          }

          if (mapa?.business_process_list_id !== null) {
            setMapa(mapa);
          } else {
            setMapa({ ...mapa, adding: true });
          }
        } else {
          setMapa(firstMapa);
        }

        // Informacija o praznim poljima posle prvog čuvanja nove mape
        if (location.state?.savedEmptyFields) {
          setSavedEmptyFields(location.state.savedEmptyFields);
          // prikazuje se jednom — posle osvežavanja (F5) poruke više nema
          navigate(location.pathname, { replace: true, state: null });
        }

        setLoading(false);
      })
      .catch((error) => {

        setLoading(false);
      });
  }, []);

  const handleChangeOrganizationUnit = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => {
      return {
        ...mapa,

        business_process_list: {
          organization_unit_id: value.value.id,
          organization_unit_name: value.value.name,
          level: value.value.level,
        },
      };
    });
  };

  const handleChangeProcess = (value) => {
    // Izbor procesa NE snima izmenu — izvedena polja se računaju lokalno iz
    // već učitanih podataka, a upis se dešava tek na "Sačuvajte mapu procesa".
    const selected = value.value;

    const headEntry = designations?.find(
      (d) => d.id === selected.manager_employee_id
    );
    const organization_unit_head = headEntry
      ? headEntry.name
      : selected.manager
      ? `${selected.manager.first_name} ${selected.manager.last_name}`
      : null;

    setMapa((mapa) => {
      return {
        ...mapa,
        business_process_list: mapa.business_process_list
          ? { ...mapa.business_process_list, ...selected }
          : { ...selected },
        business_process_list_id: selected.id,
        process: { ...mapa.process, ...selected },
        organization_unit_head,
      };
    });
    setUnsavedData(true);
  };
  const calculateProcessOwner = (owners, des) => {
    const procOwners = owners.map((own) => {
      const person = des.find((des) => des.id === own.employee_id);
      return person;
    });

    setMapa((mapa) => {
      return { ...mapa, procOwners: procOwners };
    });
  };

  const handleAddNewActivitiItem = () => {
    if (newActivityValidationErrors) {
      setNewActivityValidationErrors((errors) => {
        const { no_activity, ...rest } = errors;
        return rest;
      });
    }
    setNewActivity({
      name: "",
      description: "",
      description_addition: "",
      adding: true,
      process_map_id: mapa.id,
      procedure_id: null,
    });
  };

  const handleChangeActivitiName = (id) => {
    return function (e) {
      setMapa((mapa) => {
        return {
          ...mapa,
          activities: mapa.activities.map((activiti, index) => {
            if (index === id) {
              return { ...activiti, name: e.target.value };
            } else {
              return activiti;
            }
          }),
        };
      });
    };
  };

  const handleChangeNewActivity = (e, key) => {
    if (e.target.value.trimStart()) {
      if (newActivityValidationErrors) {
        setNewActivityValidationErrors((errors) => {
          const { [key]: prop, ...rest } = errors;
          return rest;
        });
      }
    }

    setNewActivity((activity) => {
      return { ...activity, [key]: e.target.value.trimStart() };
    });
  };

  const handleChangeActivitiDescription = (id) => {
    return function (e) {
      setMapa((mapa) => {
        return {
          ...mapa,
          activities: mapa.activities.map((activiti, index) => {
            if (index === id) {
              return { ...activiti, description: e.target.value };
            } else {
              return activiti;
            }
          }),
        };
      });
    };
  };

  const handleUpdateActivity = (activity) => {
    setLoading(true);
    baseRequest
      .put("/activity", activity)
      .then((res) => {
        setLoading(false);

        setMapa((mapa) => {
          const newActivities = mapa.activities.map((act) => {
            if (act.id === activity.id) {
              return res.data.data;
            }
            return act;
          });
          return {
            ...mapa,
            activities: newActivities,
          };
        });
        setMapaList((mapalist) => {
          const newActivities = mapa.activities.map((act) => {
            if (act.id === activity.id) {
              return res.data.data;
            }
            return act;
          });

          return {
            ...mapalist,
            [mapa.id]: {
              ...mapa,
              activities: newActivities,
            },
          };
        });
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const handleSaveNewActivity = () => {
    // Validacija pre spinnera — neuspela validacija ne sme da ostavi overlay
    if (validateMapaActivity(newActivity)) {
      return;
    }

    setLoading(true);

    baseRequest
      .post("/activity", newActivity)
      .then((res) => {
        setLoading(false);
        setMapa((mapa) => {
          //const { adding, edit, ...rest } = mapa;
          return {
            ...mapa,
            activities: mapa.activities
              ? [...mapa.activities, res.data.data]
              : [res.data.data],
          };
        });
        setMapaList((mapalist) => {
          //  const { adding, edit, ...rest } = mapa;
          return {
            ...mapalist,
            [mapa.id]: {
              ...mapa,
              activities: mapa.activities
                ? [...mapa.activities, res.data.data]
                : [res.data.data],
            },
          };
        });
        setNewActivity(null);
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const handleSetEditActivity = (id) => {
    if (
      mapa.activities.some((el) => el.editing) ||
      activeProcedure?.activities.some((el) => el.editing)
    ) {
      return;
    }
    setMapa((mapa) => {
      const newActivities = mapa.activities.map((activity) => {
        if (activity.id === id) {
          return { ...activity, editing: true };
        }
        return activity;
      });
      return { ...mapa, activities: newActivities };
    });
  };

  const handleChangeActivity = (e, id, key) => {
    setMapa((mapa) => {
      const newActivities = mapa.activities.map((activity) => {
        if (activity.id === id) {
          return { ...activity, [key]: e.target.value.trimStart() };
        }
        return activity;
      });
      return { ...mapa, activities: newActivities };
    });
  };

  const handleSaveActivity = (id) => {
    setMapa((mapa) => {
      const newActivities = mapa.activities.map((activity) => {
        if (activity.id === id) {
          const { editing, ...rest } = activity;
          return rest;
        }
        return activity;
      });
      return { ...mapa, activities: newActivities };
    });
  };

  const handleChange = (key) => {
    return function (e) {
      setUnsavedData(true);
      setMapa((mapa) => {
        return { ...mapa, [key]: e.target.value.trimStart() };
      });
    };
  };

  const handleSelectCorellationProcess = (selection) => {
    // BUG-23: čuvamo kao JSON niz imena (robusno na specijalne karaktere).
    const items = Array.isArray(selection) ? selection : (selection ? [selection] : []);
    const names = items.map((s) => s?.value?.name || s?.label).filter(Boolean);
    setUnsavedData(true);
    setMapa((mapa) => {
      return { ...mapa, correlation_to_other_processes: JSON.stringify(names) };
    });
  };

  // BUG-23: parsira — JSON niz ili legacy comma-string/single string.
  const parseCorrelations = (raw) => {
    if (!raw) return [];
    const trimmed = String(raw).trim();
    if (trimmed.startsWith("[")) {
      try {
        const arr = JSON.parse(trimmed);
        if (Array.isArray(arr)) return arr.filter(Boolean);
      } catch (e) {}
    }
    return trimmed.split(",").map((s) => s.trim()).filter(Boolean);
  };

  const clearCorrelation = () => {
    setUnsavedData(true);
    setMapa((mapa) => {
      return { ...mapa, correlation_to_other_processes: null };
    });
  };

  const handleChangeResponsibleDesignations = (id) => {
    return function (value) {
      const responsibles = value.map((item) => {
        return { designation_id: item.value.id };
      });
      setMapa((mapa) => {
        return {
          ...mapa,

          activities: mapa.activities.map((el, index) => {
            if (index === id) {
              return {
                ...el,
                designations: responsibles,
                selectedResponsibilityDesignations: value,
              };
            }
            return el;
          }),
        };
      });
    };
  };

  const handleChangeDynamicDescription = (id) => {
    return function (e) {
      setMapa((mapa) => {
        return {
          ...mapa,

          activities: mapa.activities.map((el, index) => {
            if (index === id) {
              return { ...el, description_addition: e.target.value };
            }
            return el;
          }),
        };
      });
    };
  };

  const handleChangeDocumentPath = (id) => {
    return function (value) {
      setMapa((mapa) => {
        return {
          ...mapa,

          activities: mapa.activities.map((el, index) => {
            if (index === id) {
              return { ...el, documents: [value] };
            }
            return el;
          }),
        };
      });
    };
  };

  // Approval field handlers
  const handleChangePreparedBy = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({
      ...mapa,
      prepared_by_employee_id: value.value.id,
      prepared_by: value.value,
    }));
  };

  const handleChangeControlledBy = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({
      ...mapa,
      controlled_by_employee_id: value.value.id,
      controlled_by: value.value,
    }));
  };

  const handleChangeApprovedBy = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({
      ...mapa,
      approved_by_employee_id: value.value.id,
      approved_by: value.value,
    }));
  };

  const handleChangePreparedAt = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({ ...mapa, prepared_at: value }));
  };

  const handleChangeControlledAt = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({ ...mapa, controlled_at: value }));
  };

  const handleChangeApprovedAt = (value) => {
    setUnsavedData(true);
    setMapa((mapa) => ({ ...mapa, approved_at: value }));
  };

  // Procedure documentation handlers
  const handleChangeProcedureField = (field, value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({ ...proc, [field]: value }));
    setMapa((mapa) => ({
      ...mapa,
      procedures: mapa.procedures.map((p) =>
        p.id === activeProcedure?.id ? { ...p, [field]: value } : p
      ),
    }));
  };

  const handleChangeResponsibilityRow = (rowIndex, field, value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => {
      const rows = [...(proc.responsibility_authorization || [])];
      if (field === "employee") {
        rows[rowIndex] = {
          ...rows[rowIndex],
          employee_id: value.value.id,
          employee_name: value.value.name,
        };
      } else if (field === "designation") {
        rows[rowIndex] = {
          ...rows[rowIndex],
          designation_id: value.value.id,
          designation_name: value.value.name,
        };
      }
      return { ...proc, responsibility_authorization: rows };
    });
  };

  const handleAddResponsibilityRow = () => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({
      ...proc,
      responsibility_authorization: [
        ...(proc.responsibility_authorization || []),
        { employee_id: null, employee_name: "", designation_id: null, designation_name: "" },
      ],
    }));
  };

  const handleRemoveResponsibilityRow = (rowIndex) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({
      ...proc,
      responsibility_authorization: (proc.responsibility_authorization || []).filter(
        (_, i) => i !== rowIndex
      ),
    }));
  };

  const handleChangeProcedurePreparedBy = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({
      ...proc,
      prepared_by_employee_id: value.value.id,
      prepared_by: value.value,
    }));
  };

  const handleChangeProcedureControlledBy = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({
      ...proc,
      controlled_by_employee_id: value.value.id,
      controlled_by: value.value,
    }));
  };

  const handleChangeProcedureApprovedBy = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({
      ...proc,
      approved_by_employee_id: value.value.id,
      approved_by: value.value,
    }));
  };

  const handleChangeProcedurePreparedAt = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({ ...proc, prepared_at: value }));
  };

  const handleChangeProcedureControlledAt = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({ ...proc, controlled_at: value }));
  };

  const handleChangeProcedureApprovedAt = (value) => {
    setUnsavedData(true);
    setActiveProcedure((proc) => ({ ...proc, approved_at: value }));
  };

  const handleSubmitMapa = () => {
    // setLoading(true);
    // baseRequest
    //   .post("/process_map", mapa)
    //   .then((res) => {
    //     setLoading(false);
    //     setMapaList((list) => {
    //       return { ...list, [res.data.data.id]: { ...res.data.data, ...mapa } };
    //     });
    //     setMapa((mapa) => {
    //       return { ...mapa, id: res.data.data.id };
    //     });
    //   })
    //   .catch((err) => console.log(err));
    // Nepotpuna mapa se može sačuvati; posle uspeha se samo navode prazna polja
    setSavedEmptyFields(null);
    const emptyFields = getEmptyOptionalFields(mapa);

    // validateMapaActivity(newActivity);
    //const length = Object.keys(mapaList).length;

    // const id = length ? length + 1 : 1;
    setLoading(true);

    // Nova mapa (bez id) nastaje tek sada: POST pa PUT sa podacima (isti API)
    const isNew = !mapa.id;
    let createdId = null;
    const saveMapa = isNew
      ? baseRequest.post("/process_map", {}).then((res) => {
          createdId = res.data.data.id;
          return baseRequest.put("/process_map", { ...mapa, id: createdId });
        })
      : baseRequest.put("/process_map", mapa);
    const requests = [saveMapa];

    if (activeProcedure) {
      requests.push(baseRequest.put("/procedure", activeProcedure));
    }

    Promise.all(requests)
      .then(([mapaRes, procRes]) => {
        setLoading(false);
        setUnsavedData(false);
        const savedEmpty = emptyFields.length ? emptyFields : null;
        // Nova mapa dobija svoju adresu; informacija se prenosi na učitanu mapu
        if (String(params.id) !== String(mapaRes.data.data.id)) {
          navigate(`/admin/mape-procesa/${mapaRes.data.data.id}`, {
            replace: true,
            state: { savedEmptyFields: savedEmpty },
          });
          return;
        }
        setSavedEmptyFields(savedEmpty);
        if (mapa.adding) {
          setMapa((mapa) => {
            const { adding, ...rest } = mapa;
            return { ...rest, ...mapaRes.data.data };
          });
          setMapaList((mapaList) => {
            const { adding, ...rest } = mapa;
            return {
              ...mapaList,
              [mapaRes.data.data.id]: { ...rest, ...mapaRes.data.data },
            };
          });
        } else {
          setMapa((mapa) => {
            const { edit, ...rest } = mapa;
            return { ...rest, ...mapaRes.data.data };
          });
          setMapaList((mapaList) => {
            const { edit, ...rest } = mapa;
            return {
              ...mapaList,
              [mapaRes.data.data.id]: { ...rest, ...mapaRes.data.data },
            };
          });
        }
        if (procRes && activeProcedure) {
          setActiveProcedure(procRes.data.data);
          setMapa((mapa) => {
            const existing = Array.isArray(mapa.procedures) ? mapa.procedures : [];
            const updatedList = existing.some(
              (pr) => pr.id === procRes.data.data.id
            )
              ? existing.map((pr) =>
                  pr.id === procRes.data.data.id ? procRes.data.data : pr
                )
              : [...existing, procRes.data.data];
            return { ...mapa, procedures: updatedList };
          });
        }
      })
      .catch((error) => {
        // Ako je zapis nastao, a čuvanje podataka nije uspelo, sledeći pokušaj
        // ide na isti zapis (bez nove prazne mape)
        if (createdId) {
          setMapa((mapa) => ({ ...mapa, id: createdId }));
        }
        showActionError(error);
        setLoading(false);

      });

    // setMapaList((list) => {
    //   return { ...list, [id]: mapa };
    // });
    // setMapa((mapa) => {
    //   return { ...mapa, id };
    // });
  };

  // Zapis mape nastaje tek na „Sačuvajte mapu procesa“ — „+“ samo otvara novu mapu
  const addNewMapa = () => {
    navigate("/admin/mape-procesa/new");
  };

  const handleAddNewProcedure = () => {
    setNewProcedure({
      name: "",
      code: calculateProcedureCode(processes, mapa),
      process_map_id: mapa.id,
    });
  };

  const handleAddNewRisk = () => {
    setNewRisk({
      name: "",
      process_map_id: mapa.id,
      business_process_list_id: mapa.business_process_list_id,
    });
    // setLoading(true);
    // baseRequest
    //   .post(
    //     "/procedure",
    //     { process_map_id: mapa.id },
    //     { withCredentials: true }
    //   )
    //   .then((res) => {
    //     setLoading(false);
    //     setNewProcedure({
    //       ...res.data.data,
    //       name: "",
    //       code: calculateProcedureCode(processes, mapa),
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setLoading(false);
    //   });
  };

  const handleChangeNewProceduraName = (e) => {
    if (e.target.value.trimStart()) {
      setNewProcedureValidationErrors(null);
    }
    setNewProcedure((procedure) => {
      return { ...procedure, name: e.target.value.trimStart() };
    });
  };

  const handleChangeNewRiskName = (e) => {
    if (e.target.value.trimStart()) {
      setNewRiskValidationerror(null);
    }
    setNewRisk((risk) => {
      return { ...risk, name: e.target.value.trimStart() };
    });
  };

  const handleSaveNewProcedure = () => {
    if (validateNewProcedure(newProcedure)) {
      return;
    }
    setLoading(true);
    baseRequest
      .post("/procedure", newProcedure)
      .then((res) => {
        setLoading(false);
        setMapa((mapa) => {
          return {
            ...mapa,
            procedures: mapa.procedures
              ? [...mapa.procedures, res.data.data]
              : [res.data.data],
          };
        });
        setMapaList((mapalist) => {
          return {
            ...mapalist,
            [mapa.id]: {
              ...mapalist[mapa.id],
              procedures: mapalist[mapa.id].procedures
                ? [...mapalist[mapa.id].procedures, res.data.data]
                : [res.data.data],
            },
          };
        });
        setActiveProcedure(res.data.data);
        setNewProcedure(null);
      })
      .catch((error) => {
        showActionError(error);

        setLoading(false);
      });
  };

  const handleSaveNewRisk = () => {
    if (validateNewRisk(newRisk?.name)) {
      setNewRiskValidationerror(true);
      return;
    }
    setLoading(true);

    const formularNumebr =
      mapa?.risk_forms.length > 0
        ? `${mapa.business_process_list.code}.${mapa.risk_forms.length + 1}`
        : `${mapa.business_process_list.code}.1`;
    baseRequest
      .post(
        "risk_form",
        { ...newRisk, number: formularNumebr }
      )
      .then((res) => {
        setLoading(false);
        setRiskForms((forms) => {
          return forms ? [...forms, res.data.data] : [res.data.data];
        });
        setMapa((mapa) => {
          return {
            ...mapa,
            risk_forms: mapa.risk_forms
              ? [...mapa.risk_forms, res.data.data]
              : [res.data.data],
          };
        });
        setNewRisk(null);
      })

      .catch((err) => {
        showActionError(err);
        setLoading(false);
      });
  };

  const handleAddNewProcedureRow = () => {
    setNewProcedureRow({
      name: "",
      description: "",
      symbol_type: "activity",
      due_date: "",
      activities_designations: [],
      documents: [],
      process_map_id: mapa.id,
      procedure_id: activeProcedure.id,
    });
  };

  const handleDeleteNewProcedure = () => {
    setNewProcedureValidationErrors(null);
    setNewProcedure(null);
  };

  const handleChangeNewProcedureRow = (e, key) => {
    if (e.target.value.trimStart()) {
      if (newProcedureRowValidationsError) {
        setNewProcedureRowValidationsError((errors) => {
          const { [key]: prop, ...rest } = errors;
          return rest;
        });
      }
    }
    setNewProcedureRow((row) => {
      return { ...row, [key]: e.target.value.trimStart() };
    });
  };

  const handleChangeProcedureRow = (e, key, row) => {
    // greška validacije se skida tek kad polje ima sadržaj; sama vrednost se
    // uvek upisuje, da bi opciono polje moglo da se isprazni i tako sačuva
    if (e.target.value.trimStart() && oldProcedureRowValidationsError) {
      setOldProcedureRowValidationsError((errors) => {
        const { [key]: prop, ...rest } = errors;
        return rest;
      });
    }
    setActiveProcedure((procedure) => {
      const newActivities = procedure.activities.map((act) => {
        if (act.id === row.id) {
          return { ...act, [key]: e.target.value };
        }
        return act;
      });
      return { ...procedure, activities: newActivities };
    });
  };

  const handleSelectProceduraRowResponsibles = (row) => {
    return function (value) {
      if (value.length && oldProcedureRowValidationsError) {
        setOldProcedureRowValidationsError((errors) => {
          const { activities_designations, ...rest } = errors;

          return rest;
        });
      }
      setActiveProcedure((procedure) => {
        const newActivities = procedure.activities.map((act) => {
          if (act.id === row.id) {
            return { ...act, activities_designations: value };
          }
          return act;
        });
        return { ...procedure, activities: newActivities };
      });
    };
  };

  const handleChangeProcedureRowDueDate = (row) => {
    return function (date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      month = month >= 10 ? month : `0${month}`;
      day = day >= 10 ? day : `0${day}`;
      let currentDate = `${year}-${month}-${day}`;
      setActiveProcedure((procedure) => {
        const newActivities = procedure.activities.map((act) => {
          if (act.id === row.id) {
            return { ...act, due_date: currentDate };
          }
          return act;
        });
        return { ...procedure, activities: newActivities };
      });
    };
  };

  const handleSetEditProcedure = (proc) => {
    setActiveProcedure(proc);
    setMapa((mapa) => {
      const newProceduresList = mapa.procedures.map((procedure) => {
        if (procedure.id === proc.id) {
          return { ...procedure, editing: true };
        }
        return procedure;
      });
      return { ...mapa, procedures: newProceduresList };
    });
  };

  const handleSetEditProcedureRow = (row) => {
    setActiveProcedure((procedure) => {
      const newActivities = procedure.activities.map((act) => {
        if (act.id === row.id) {
          return { ...act, editing: true };
        }
        return act;
      });
      return { ...procedure, activities: newActivities };
    });
  };

  const handleChangeProcedureName = (e, id) => {
    setMapa((mapa) => {
      const newProceduresList = mapa.procedures.map((procedure) => {
        if (procedure.id === id) {
          return { ...procedure, name: e.target.value.trimStart() };
        }
        return procedure;
      });
      return { ...mapa, procedures: newProceduresList };
    });
  };

  const handleSaveProcedure = (id) => {
    setMapa((mapa) => {
      const newProceduresList = mapa.procedures.map((procedure) => {
        if (procedure.id === id) {
          const { editing, ...rest } = procedure;
          return rest;
        }
        return procedure;
      });
      return { ...mapa, procedures: newProceduresList };
    });
  };

  const handleUpdateProcedure = (procedure) => {
    setLoading(true);
    baseRequest
      .put("/procedure", procedure)
      .then((res) => {
        setLoading(false);
        setMapa((mapa) => {
          const newProcedures = mapa.procedures.map((pr) => {
            if (pr.id === procedure.id) {
              return res.data.data;
            }
            return pr;
          });
          return {
            ...mapa,
            procedures: newProcedures,
          };
        });
        setMapaList((mapalist) => {
          const newProcedures = mapa.procedures.map((pr) => {
            if (pr.id === procedure.id) {
              return res.data.data;
            }
            return pr;
          });
          return {
            ...mapalist,
            [mapa.id]: {
              ...mapalist[mapa.id],
              procedures: newProcedures,
            },
          };
        });
        if (activeProcedure.id === procedure.id) {
          setActiveProcedure(res.data.data);
        }
      })
      .catch((error) => {
        showActionError(error);
      });
  };

  const handleDeleteNewActivity = () => {
    setNewActivityValidationErrors(null);
    setNewActivity(null);
  };

  function handleSelectDueDate(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    month = month >= 10 ? month : `0${month}`;
    day = day >= 10 ? day : `0${day}`;
    let currentDate = `${year}-${month}-${day}`;
    setNewProcedureRow((formular) => {
      return {
        ...formular,
        ["due_date"]: currentDate,
      };
    });
  }

  const handleSelectNewProcedureResponsibleDesignations = (value) => {
    if (value.length && newProcedureRowValidationsError) {
      setNewProcedureRowValidationsError((errors) => {
        const { activities_designations, ...rest } = errors;

        return rest;
      });
    }
    setNewProcedureRow((row) => {
      return { ...row, activities_designations: value };
    });
  };

  const handleAddLink = (value) => {
    setNewProcedureRow((row) => {
      return { ...row, link: value };
    });
  };

  const handleChangeLink = (e, key) => {
    setNewProcedureRow((row) => {
      return {
        ...row,
        link: { ...row.link, [key]: e.target.value.trimStart() },
      };
    });
  };

  const handleSaveNewProcedureRow = () => {
    if (validateNewProcedureRow(newProcedureRow)) {
      return;
    }

    const formattedDesignations = newProcedureRow.activities_designations.map(
      (item) => {
        return { designation_id: item.value.id };
      }
    );
    setLoading(true);

    baseRequest
      .post(
        "/activity",
        {
          ...newProcedureRow,
          documents: cleanDocuments(newProcedureRow.documents),
          designations: formattedDesignations,
        }
      )
      .then((res) => {
        setLoading(false);

        setActiveProcedure((procedure) => {
          return {
            ...procedure,
            activities: procedure.activities
              ? [...procedure.activities, res.data.data]
              : [res.data.data],
          };
        });
        setMapa((mapa) => {
          const newProceduresList = mapa.procedures.map((procedure) => {
            if (procedure.id === activeProcedure.id) {
              return {
                ...procedure,
                activities: procedure.activities
                  ? [...procedure.activities, res.data.data]
                  : [res.data.data],
              };
            }
            return procedure;
          });
          return {
            ...mapa,
            procedures: newProceduresList,
          };
        });

        setMapaList((mapalist) => {
          const newProceduresList = mapa.procedures.map((procedure) => {
            if (procedure.id === activeProcedure.id) {
              return {
                ...procedure,
                activities: procedure.activities
                  ? [...procedure.activities, res.data.data]
                  : [res.data.data],
              };
            }
            return procedure;
          });
          return {
            ...mapalist,
            [mapa.id]: { ...mapa, procedures: newProceduresList },
          };
        });
        setNewProcedureRow(null);
      })
      .catch((error) => {
        showActionError(error);

        setLoading(false);
      });
  };

  const handleDeleteNewProcedureRow = () => {
    setNewProcedureRowValidationsError(null);
    setNewProcedureRow(null);
  };

  const getEmptyOptionalFields = (mapa) =>
    optionalMapFields
      .filter(({ key }) => !mapa[key])
      .map(({ label }) => label);

  const validateMapaActivity = (activity) => {
    const activityValidationErrors = {};

    const fields = ["name", "description"];
    if (activity) {
      fields.forEach((field) => {
        if (activity[field].length === 0) {
          activityValidationErrors[field] = true;
        }
      });
      if (Object.keys(activityValidationErrors).length) {
        setNewActivityValidationErrors(activityValidationErrors);
        return true;
      }
    } else {
      setNewActivityValidationErrors({ no_activity: true });

      return true;
    }
    return false;
  };

  const validateNewProcedure = (procedure) => {
    if (!procedure?.name) {
      setNewProcedureValidationErrors(true);
      return true;
    }
    return false;
  };

  const validateOldProcedureRow = (row) => {
    if (validateProcedureRow(row)) {
      setOldProcedureRowValidationsError(validateProcedureRow(row));
      return true;
    }
    return false;
  };

  const validateNewProcedureRow = (row) => {
    if (validateProcedureRow(row)) {
      setNewProcedureRowValidationsError(validateProcedureRow(row));

      return true;
    }
    return false;
  };

  const handleAddNewMapaDocumentList = (isNewRow, row) => {
    const emptyDocument = { id: uuidv4(), name: "", path: "" };
    if (isNewRow) {
      setNewProcedureRow((row) => ({
        ...row,
        documents: [...(row?.documents || []), emptyDocument],
      }));
    } else {
      setActiveProcedure((procedure) => {
        const newActivities = procedure.activities.map((act) => {
          if (act.id === row.id) {
            return {
              ...act,
              activities_documents: [
                ...(act.activities_documents || []),
                emptyDocument,
              ],
            };
          }
          return act;
        });
        return { ...procedure, activities: newActivities };
      });
    }
  };

  const handleChangeNewMapaDocument = (isNewRow, key, e, row) => {
    const value = e.target.value.trimStart();
    const updateLastDocument = (documents) =>
      documents.map((doc, index) =>
        index === documents.length - 1 ? { ...doc, [key]: value } : doc
      );
    if (isNewRow) {
      setNewProcedureRow((row) => ({
        ...row,
        documents: updateLastDocument(row?.documents || []),
      }));
    } else {
      setActiveProcedure((procedure) => {
        const newActivities = procedure.activities.map((act) => {
          if (act.id === row.id) {
            return {
              ...act,
              activities_documents: updateLastDocument(
                act.activities_documents || []
              ),
            };
          }
          return act;
        });

        return { ...procedure, activities: newActivities };
      });
    }
  };

  // Ključ sa listom dokumenata se ne briše — prazna lista ostaje niz
  const handleRejectMapaDukument = (isNewRow, row) => {
    if (isNewRow) {
      setNewProcedureRow((row) => ({
        ...row,
        documents: (row?.documents || []).slice(0, -1),
      }));
    } else {
      setActiveProcedure((procedure) => {
        const newActivities = procedure.activities.map((act) => {
          if (act.id === row.id) {
            return {
              ...act,
              activities_documents: (act.activities_documents || []).slice(
                0,
                -1
              ),
            };
          }
          return act;
        });
        return { ...procedure, activities: newActivities };
      });
    }
  };

  const handleAddMapaDocumentName = (isNewRow, row, name) => {
    const document = { id: uuidv4(), name, path: "", saved: true };
    if (isNewRow) {
      setNewProcedureRow((row) => ({
        ...row,
        documents: [...(row?.documents || []), document],
      }));
    } else {
      setActiveProcedure((procedure) => ({
        ...procedure,
        activities: procedure.activities.map((act) =>
          act.id === row.id
            ? {
                ...act,
                activities_documents: [
                  ...(act.activities_documents || []),
                  document,
                ],
              }
            : act
        ),
      }));
    }
  };

  const handleRemoveMapaDocument = (isNewRow, row, documentId) => {
    if (isNewRow) {
      setNewProcedureRow((row) => ({
        ...row,
        documents: (row?.documents || []).filter(
          (doc) => doc.id !== documentId
        ),
      }));
    } else {
      setActiveProcedure((procedure) => ({
        ...procedure,
        activities: procedure.activities.map((act) =>
          act.id === row.id
            ? {
                ...act,
                activities_documents: (act.activities_documents || []).filter(
                  (doc) => doc.id !== documentId
                ),
              }
            : act
        ),
      }));
    }
  };

  // Otpremanje fajla u koloni PROPRATNI DOKUMENTI: zapis nastaje odmah (bez
  // aktivnosti), a za red se vezuje pri snimanju reda kroz documents[].id.
  const handleUploadMapaDocument = async (isNewRow, row, file) => {
    const localError = validateFileLocally(file);
    if (localError) {
      setErrorMessages(localError);
      return;
    }
    try {
      const uploaded = await uploadActivityDocument(mapa.id, file);
      const document = { ...uploaded, saved: true };
      setErrorMessages(null);
      if (isNewRow) {
        setNewProcedureRow((current) => ({
          ...current,
          documents: [...(current?.documents || []), document],
        }));
      } else {
        setActiveProcedure((procedure) => ({
          ...procedure,
          activities: procedure.activities.map((act) =>
            act.id === row.id
              ? {
                  ...act,
                  activities_documents: [
                    ...(act.activities_documents || []),
                    document,
                  ],
                }
              : act
          ),
        }));
      }
    } catch (error) {
      setErrorMessages(uploadErrorMessage(error));
    }
  };

  const handleSaveNewMapaDocument = (isNewRow, row) => {
    if (isNewRow) {
      setNewProcedureRow((row) => {
        return {
          ...row,
          documents: row.documents.map((document, index) => {
            if (index === row.documents.length - 1) {
              return { ...document, saved: true };
            }
            return document;
          }),
        };
      });
    }
    // else {
    //   setActiveProcedure(procedure => {
    //     const newActivities = procedure.activities.map(act => {
    //       if(act.id === row.id) {
    //         return {...act, activities_documents: act.activities_documents.map((doc, index) => {
    //           if(index === act.activities_documents.length - 1) {
    //             return {...doc, saved:}
    //           }
    //         })}
    //       }
    //     })
    //   })
    // }
  };

  const handleSetEditMapa = () => {
    setSavedEmptyFields(null);
    setMapa((mapa) => {
      return { ...mapa, edit: true };
    });
  };

  const handleUpdateProcedureRow = (row) => {
    if (validateOldProcedureRow(row)) {
      return;
    }
    const formattedDesignations = row.activities_designations.map((item) => {
      return {
        designation_id: item.value ? item.value.id : item.designation_id,
      };
    });
    setLoading(true);
    const { process_map_id, ...rest } = row;
    baseRequest
      .put(
        "/activity",
        {
          ...row,
          designations: formattedDesignations,
          documents: cleanDocuments(row.activities_documents),
        }
      )
      .then((res) => {
        setLoading(false);

        setActiveProcedure((procedure) => {
          const newActivities = procedure.activities.map((act) => {
            if (act.id === row.id) {
              return res.data.data;
            }
            return act;
          });
          return {
            ...procedure,
            activities: newActivities,
          };
        });
        setMapa((mapa) => {
          const newProceduresList = mapa.procedures.map((procedure) => {
            if (procedure.id === activeProcedure.id) {
              return {
                ...procedure,
                activities: procedure.activities.map((act) => {
                  if (act.id === row.id) {
                    return res.data.data;
                  }
                  return act;
                }),
              };
            }
            return procedure;
          });
          return {
            ...mapa,
            procedures: newProceduresList,
          };
        });

        setMapaList((mapalist) => {
          const newProceduresList = mapa.procedures.map((procedure) => {
            if (procedure.id === activeProcedure.id) {
              return {
                ...procedure,
                activities: procedure.activities.map((act) => {
                  if (act.id === row.id) {
                    return res.data.data;
                  }
                  return act;
                }),
              };
            }
            return procedure;
          });
          return {
            ...mapalist,
            [mapa.id]: { ...mapa, procedures: newProceduresList },
          };
        });
        setNewProcedureRow(null);
      })
      .catch((error) => {
        showActionError(error);

        setLoading(false);
      });
  };

  const HandleDeleteMapa = () => {
    // Nova mapa još ne postoji u bazi (QA-02) — brisanje je samo odustajanje
    if (!mapaToDelete.id) {
      setMapaToDelete(null);
      setUnsavedData(false);
      navigate("/admin/mape-procesa");
      return;
    }
    setLoading(true);
    baseRequest
      .delete(`/process_map/${mapaToDelete.id}`)
      .then((res) => {
        setLoading(false);
        setMapaToDelete(null);
        navigate("/admin/mape-procesa");
        // const { [res.data.data.id]: deletedMapa, ...rest } = mapaList;
        // const activeMapa =
        //   Object.keys(rest).length > 0 ? rest[Object.keys(rest)[0]] : null;
        // setMapa(activeMapa);
        // setMapaList(rest);
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const handleDeleteActivity = () => {
    setLoading(true);
    baseRequest
      .delete(`/activity/${activityToDelete.id}`)
      .then((res) => {
        setLoading(false);

        if (!res.data.data.procedure_id) {
          setMapa((mapa) => {
            const newActivities = mapa.activities.filter((act) => {
              return act.id !== res.data.data.id;
            });
            setMapaList((mapalist) => {
              return {
                ...mapalist,
                [mapa.id]: { ...mapalist[mapa.id], activities: newActivities },
              };
            });
            return { ...mapa, activities: newActivities };
          });
        } else {
          setActiveProcedure((procedure) => {
            const newActivities = procedure.activities.filter(
              (act) => act.id !== res.data.data.id
            );

            setMapa((mapa) => {
              const newProcedures = mapa.procedures.map((proc) => {
                if (proc.id === res.data.data.procedure_id) {
                  return { ...proc, activities: newActivities };
                }
                return proc;
              });
              setMapaList((mapalist) => {
                return {
                  ...mapalist,
                  [res.data.data.process_map_id]: {
                    ...mapalist[res.data.data.process_map_id],
                    procedures: newProcedures,
                  },
                };
              });
              return { ...mapa, procedures: newProcedures };
            });
            return { ...procedure, activities: newActivities };
          });
        }
        if (!res.data.data.procedure_id) {
          setNewActivity(null);
        } else {
          setNewProcedureRow(null);
        }

        setActivityToDelete(null);
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const handleDeleteProcedure = () => {
    setLoading(true);
    baseRequest
      .delete(`/procedure/${procedureToDelete.id}`)
      .then((res) => {
        setLoading(false);

        setMapa((mapa) => {
          const newProcedures = mapa.procedures.filter((act) => {
            return act.id !== res.data.data.id;
          });
          setMapaList((mapalist) => {
            return {
              ...mapalist,
              [mapa.id]: { ...mapalist[mapa.id], procedures: newProcedures },
            };
          });
          return { ...mapa, procedures: newProcedures };
        });
        setNewProcedure(null);
        setProcedureToDelete(null);
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const calculateProcedureCode = (pr, mapa) => {
    const relativeProcesses = pr.filter(
      (proc) =>
        proc.business_process_id ===
        mapa.business_process_list.business_process_id
    );

    const index = relativeProcesses.findIndex(
      (el) => el.id === mapa.business_process_list.id
    );

    const procedureIndex = mapa.procedures.length
      ? mapa.procedures.length + 1
      : 1;
    return `${mapa.business_process_list.code}-${procedureIndex}`;
  };

  const validateNewRisk = (name) => {
    if (!name) {
      setNewRiskValidationerror(true);
      return true;
    }
  };

  const validateRisk = (name) => {
    if (!name) {
      setRiskValidationError(true);
      return true;
    }
  };

  const handleSetEditRisk = (risk) => {
    setActiveRisk(risk);
    setMapa((mapa) => {
      const newRiskList = mapa.risk_forms.map((form) => {
        if (form.id === risk.id) {
          return { ...form, editing: true };
        }
        return form;
      });
      return { ...mapa, risk_forms: newRiskList };
    });
  };

  const handleChangeRiskName = (risk) => {
    return function (e) {
      if (e.target.value.trimStart()) {
        setRiskValidationError(null);
      }

      setActiveRisk((activeRisk) => {
        return { ...activeRisk, name: e.target.value.trimStart() };
      });
      setMapa((mapa) => {
        const newRiskList = mapa.risk_forms.map((form) => {
          if (form.id === risk.id) {
            return { ...form, name: e.target.value.trimStart() };
          }
          return form;
        });
        return { ...mapa, risk_forms: newRiskList };
      });
    };
  };

  const handleUpdateRisk = (risk) => {
    if (validateRisk(activeRisk.name)) {
      return;
    }
    setLoading(true);
    baseRequest
      .put("risk_form", risk)
      .then((res) => {
        setLoading(false);
        setActiveRisk(null);
        setMapa((mapa) => {
          const newRiskList = mapa.risk_forms.map((form) => {
            if (form.id === res.data.data.id) {
              return res.data.data;
            }
            return form;
          });
          return { ...mapa, risk_forms: newRiskList };
        });
      })

      .catch((err) => {
        showActionError(err);
        setLoading(false);
      });
  };

  const handleDeleteRisk = () => {
    setLoading(true);
    baseRequest
      .delete(`/risk_form/${riskToDelete.id}`)
      .then((res) => {
        setLoading(false);

        setMapa((mapa) => {
          const newRiskForms = mapa.risk_forms.map((form) => {
            if (form.id === res.data.data.id) {
              return { ...form, del: 1 };
            }
            return form;
          });
          setMapaList((mapalist) => {
            return {
              ...mapalist,
              [mapa.id]: { ...mapalist[mapa.id], risk_forms: newRiskForms },
            };
          });
          return { ...mapa, risk_forms: newRiskForms };
        });

        setRiskToDelete(null);
      })
      .catch((error) => {
        showActionError(error);
        setLoading(false);

      });
  };

  const handleDeleteNewRisk = () => {
    setNewRisk(null);
    setNewRiskValidationerror(null);
  };

  const hasEditPermission = hasUnitEditPermission;

  // Odbijen zahtev (403) mora biti vidljiv korisniku, a ne tihi neuspeh
  const showActionError = (error) => {
    setErrorMessages(
      error?.response?.status === 403
        ? "Nemate ovlašćenje za ovu akciju."
        : null
    );
  };

  // Akcije izmene vidljive su samo rolama čije zahteve server prihvata
  const canEditMapa =
    user && mapa
      ? mapa.business_process_list
        ? hasEditPermission(
            user,
            mapa.business_process_list.organization_unit_id,
            mapa.business_process_list.level
          )
        : user.role_id === ROLES.SUPER_ADMIN || user.role_id === ROLES.MANAGER
      : false;

  const calculateOpenOrganizationUnits = (user, processList, maps, units) => {
    if (user.role_id === ROLES.SUPER_ADMIN) {
      const result = processList.filter((process) => {
        // Arhivirana mapa ne zauzima proces (isto kao canAddMapa)
        const matchedMapa = maps.find((mapa) => {
          return (
            !mapa.del &&
            !mapa.is_archived &&
            mapa?.process?.business_process_id &&
            mapa.process.business_process_id === process.business_process_id &&
            mapa.process.id === process.id
          );
        });
        return matchedMapa;
      });
      let difference = processList.filter(
        (process) => !result.find((item) => item.id === process.id)
      );
      if (difference.length) {
        const formattedUnits = units.map((unit) => {
          const matchedUnit = difference.find(
            (proc) =>
              proc.organization_unit_id === unit.id && proc.level === unit.level
          );
          if (matchedUnit) {
            return { ...unit, isDisabled: undefined };
          } else {
            return { ...unit, isDisabled: true };
          }
        });

        return formattedUnits;
      } else {
        return units;
      }
    } else {
      const userMapas = maps.filter(
        (el) =>
          !el.del &&
          !el.is_archived &&
          el?.process?.organization_unit_id &&
          el.process.organization_unit_id === user.organization_unit_id &&
          el.process.level === user.level
      );

      const userProcesses = processList.filter(
        (proc) =>
          proc.organization_unit_id === user.organization_unit_id &&
          proc.level === user.level
      );

      const result = userProcesses.filter((process) => {
        const matchedMapa = userMapas.find((mapa) => {
          return mapa.process.id === process.id;
        });
        return matchedMapa;
      });
      let difference = userProcesses.filter(
        (process) => !result.find((item) => item.id === process.id)
      );

      if (difference.length) {
        const formattedUnits = units.map((unit) => {
          const matchedUnit = difference.find(
            (proc) =>
              proc.organization_unit_id === unit.id && proc.level === unit.level
          );
          if (matchedUnit) {
            return { ...unit, isDisabled: undefined };
          } else {
            return { ...unit, isDisabled: true };
          }
        });

        return formattedUnits;
      } else {
        return units;
      }
    }
  };

  const canAddMapa = (user, mapas, processList) => {
    if (user.role_id === ROLES.SUPER_ADMIN) {
      if (!processList.length) {
        return false;
      } else if (!mapas.length && processList.length) {
        return true;
      } else if (mapas.length && processList.length) {
        const result = processList.filter((process) => {
          const matchedMapa = mapas.find((mapa) => {
            return (
              !mapa.del &&
              !mapa.is_archived &&
              mapa?.process?.business_process_id &&
              mapa.process.business_process_id ===
                process.business_process_id &&
              mapa.process.id === process.id
            );
          });
          return matchedMapa;
        });
        let difference = processList.filter(
          (process) => !result.find((item) => item.id === process.id)
        );
        if (difference.length) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      const userMapas = mapas.filter(
        (el) =>
          !el.del &&
          !el.is_archived &&
          el?.process?.organization_unit_id &&
          el.process.organization_unit_id === user.organization_unit_id &&
          el.process.level === user.level
      );

      const userProcesses = processList.filter(
        (proc) =>
          proc.organization_unit_id === user.organization_unit_id &&
          proc.level === user.level
      );

      if (!userProcesses.length) {
        return false;
      } else if (!userMapas.length && userProcesses.length) {
        return true;
      } else if (userMapas.length && userProcesses.length) {
        const result = userProcesses.filter((process) => {
          const matchedMapa = userMapas.find((mapa) => {
            return mapa.business_process_list.id === process.id;
          });
          return matchedMapa;
        });
        let difference = userProcesses.filter(
          (process) => !result.find((item) => item.id === process.id)
        );

        if (difference.length) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  return (
    <>
      <div
        className="processes-header"
        style={{ padding: "15px 0", justifyContent: "space-between" }}
      >
        <div className="back-arrow">
          <img src="/images/backarrow.png" />
          <Link to="/admin/mape-procesa">Nazad</Link>
        </div>
        <div
          className="sort-options-dropdown"
          style={{ width: "200px" }}
          ref={dropdownRef}
        >
          <div
            className="sort-options-dropdown-selected"
            onClick={() => {
              setShowDropdown((state) => !state);
            }}
          >
            <span style={{ marginRight: "7px", paddingLeft: "10px" }}>
              Opcije
            </span>

            <img
              alt=""
              src="/images/sidebararrow.png"
              className="sidebar-navigation-item-arrow"
            ></img>
          </div>
          {showDropdown && (
            <ul
              className="sort-options-dropdown-options"
              style={{ left: "0", zIndex: "100", flex: 1 }}
            >
              {canEditMapa && (
                <li
                  className="sort-options-dropdown-options-item"
                  onClick={() => {
                    setShowDropdown(false);
                    handleSetEditMapa();
                  }}
                >
                  Izmenite
                </li>
              )}

              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Kreiraj novu versiju
              </li>
            </ul>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>
            {user && processes && mapa?.id && !mapa.adding && (
              <button
                className="add-btn-large"
                title="Istorija verzija"
                style={{
                  fontSize: "12px",
                  padding: "0 10px",
                  width: "auto",
                  whiteSpace: "nowrap",
                }}
                onClick={() => setShowVersionHistory(true)}
              >
                ISTORIJA
              </button>
            )}
          </div>
          <div style={{ marginRight: "10px" }}>
            {user && processes && mapa?.id && !mapa.adding && (
              <button
                className="add-btn-large"
                title="Izvezi mapu procesa u Word (DOCX)"
                style={{
                  fontSize: "12px",
                  padding: "0 10px",
                  width: "auto",
                  whiteSpace: "nowrap",
                }}
                onClick={() => downloadFile(`/export/process-map/${mapa.id}/docx`, "mapa-procesa.docx")}
              >
                DOCX
              </button>
            )}
          </div>
          <div style={{ marginRight: "10px" }}>
            {user &&
              canEditMapa &&
              mapa?.id &&
              !mapa.adding &&
              !mapa.edit && (
                <button
                  className="add-btn-large"
                  title="Premesti mapu procesa u arhivu"
                  style={{
                    fontSize: "12px",
                    padding: "0 10px",
                    width: "auto",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    if (!window.confirm("Da li ste sigurni da želite da arhivirate ovu mapu procesa?")) return;
                    baseRequest
                      .patch(`/process_map/${mapa.id}/archive`, { archived: true })
                      .then(() => navigate("/admin/mape-procesa"))
                      .catch((error) => showActionError(error));
                  }}
                >
                  ARHIVIRAJ
                </button>
              )}
          </div>
          <div style={{ marginRight: "10px" }}>
            {user && processes && rawMapas && (
              <button className="add-btn-large" onClick={handlePrint}>
                <img alt="" src="/images/printer.png"></img>
              </button>
            )}
          </div>
          <div style={{ marginRight: "10px" }}>
            {user &&
              processes &&
              rawMapas &&
              !mapa.adding &&
              canAddMapa(user, rawMapas, processes) && (
                <button className="add-btn-large" onClick={addNewMapa}>
                  <img alt="" src="/images/plus.png"></img>
                </button>
              )}
          </div>
          <div>
            {mapa &&
              mapa.business_process_list &&
              hasEditPermission(
                user,
                mapa.business_process_list.organization_unit_id,
                mapa.business_process_list.level
              ) && (
                <button
                  className="add-btn-large"
                  onClick={() => {
                    mapa.edit || mapa.adding
                      ? handleSubmitMapa()
                      : handleSetEditMapa();
                  }}
                >
                  <img
                    alt=""
                    src={
                      mapa.edit || mapa.adding
                        ? "/images/check2.png"
                        : "/images/edit.png"
                    }
                  ></img>
                </button>
              )}
          </div>
        </div>
      </div>
      {errorMessages && (
        <div className="errormessage" style={{ marginLeft: "50px" }}>
          {errorMessages}
        </div>
      )}
      <div
        className="poslovni-procesi"
        style={{
          width: "auto",
          marginLeft: "50px",
          marginTop: "30px",
        }}
      >
        {mapa && user && (
          <div
            className="poslovni-procesi-tables"
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  border: "1px solid var(--mainColor)",
                  backgroundColor: "#f0f8ff",
                  color: "var(--mainColor)",
                  fontWeight: "600",
                  fontSize: "32px",
                  textAlign: "center",
                  padding: "22px 10px",
                  textTransform: "uppercase",
                }}
              >
                Mapa procesa
              </div>
              <DropdownWrapper title="ORGANIZACIONA JEDINICA" style={wrapperTitleStyle}>
                <div style={{ display: "flex", minHeight: "70px" }}>
                  <div
                    style={{
                      width: "58%",
                      borderRight: "1px solid var(--mainColor)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DropDown
                      list={calculateOpenOrganizationUnits(
                        user,
                        processes,
                        rawMapas,
                        organization_units
                      )}
                      onChange={handleChangeOrganizationUnit}
                      isMulti={false}
                      selectedValue={
                        mapa?.business_process_list?.organization_unit_name || ""
                      }
                      disabled={!mapa.adding && !mapa.edit}
                    />
                  </div>
                  <div
                    style={{
                      width: "22%",
                      borderRight: "1px solid var(--mainColor)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f0f8ff",
                      color: "var(--mainColor)",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      fontSize: "14px",
                      textAlign: "center",
                      padding: "0 8px",
                    }}
                  >
                    ŠIFRA PROCESA:
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "var(--mainColor)",
                      fontSize: "32px",
                    }}
                  >
                    {mapa?.process?.code || ""}
                  </div>
                </div>
              </DropdownWrapper>
              <DropdownWrapper
                title="VLASNIK PROCESA"
                wrapperStyle={wrapperStyle}
                style={wrapperTitleStyle}
              >
                {mapa?.business_process_list &&
                  mapa?.business_process_list?.business_process_owners &&
                  mapa?.business_process_list?.business_process_owners.length >
                    0 && (
                    <ul className="static-list">
                      {mapa.business_process_list.business_process_owners
                        .filter((owner) => !owner.del)
                        .map((el) => {
                          // pre snimanja vlasnici nemaju naziv radnog mesta,
                          // pa se on izvodi iz već učitanih zaposlenih
                          const desigName =
                            el.name ||
                            designations?.find((d) => d.id === el.employee_id)
                              ?.designation_name;
                          return (
                            <li key={el.id}>
                              {`${el.first_name} ${el.last_name}${
                                desigName ? ` - ${desigName}` : ""
                              }`}
                            </li>
                          );
                        })}
                    </ul>
                  )}
              </DropdownWrapper>

              <DropdownWrapper
                title="PUN NAZIV ORGANIZACIJE"
                style={wrapperTitleStyle}
              >
                <div
                  style={{
                    padding: "10px",
                    color: "var(--mainColor)",
                    fontSize: "14px",
                  }}
                >
                  {mapa.edit || mapa.adding ? (
                    <input
                      value={mapa?.company_name || ""}
                      onChange={handleChange("company_name")}
                      maxLength={255}
                      placeholder="Unesite pun naziv preduzeća"
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        color: "var(--mainColor)",
                        fontSize: "14px",
                      }}
                    />
                  ) : (
                    mapa?.company_name || ""
                  )}
                </div>
              </DropdownWrapper>
              <DropdownWrapper
                title="ŠIFRA ORGANIZACIONE JEDINICE"
                style={wrapperTitleStyle}
              >
                <div style={{ display: "flex", minHeight: "70px" }}>
                  <div
                    style={{
                      width: "58%",
                      borderRight: "1px solid var(--mainColor)",
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      color: "var(--mainColor)",
                      fontSize: "14px",
                    }}
                  >
                    {mapa.edit || mapa.adding ? (
                      <input
                        value={mapa?.organization_unit_code || ""}
                        onChange={handleChange("organization_unit_code")}
                        maxLength={255}
                        placeholder="Unesite šifru (neobavezno)"
                        style={{
                          width: "100%",
                          border: "none",
                          outline: "none",
                          color: "var(--mainColor)",
                          fontSize: "14px",
                        }}
                      />
                    ) : (
                      mapa?.organization_unit_code || ""
                    )}
                  </div>
                  <div
                    style={{
                      width: "22%",
                      borderRight: "1px solid var(--mainColor)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f0f8ff",
                      color: "var(--mainColor)",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      fontSize: "14px",
                      textAlign: "center",
                      padding: "0 8px",
                    }}
                  >
                    VERZIJA:
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "var(--mainColor)",
                      fontSize: "32px",
                    }}
                  >
                    <input
                      type="text"
                      value={mapa?.version || ""}
                      placeholder="1.0"
                      onChange={handleChange("version")}
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        textAlign: "center",
                        fontSize: "32px",
                        color: "var(--mainColor)",
                        fontFamily: "inherit",
                        background: "transparent",
                      }}
                    />
                  </div>
                </div>
              </DropdownWrapper>
              <DropdownWrapper
                title="RUKOVODILAC ORGANIZACIONE JEDINICE"
                style={wrapperTitleStyle}
              >
                <div
                  style={{
                    padding: "10px",
                    color: "var(--mainColor)",
                    fontSize: "14px",
                  }}
                >
                  {mapa?.organization_unit_head || ""}
                </div>
              </DropdownWrapper>
            </div>
            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <CenterDropdownWrapper
                title="NAZIV PROCESA"
                wrapperStyle={{ marginBottom: "0" }}
              >
                <DropDown
                  isMulti={false}
                  list={calculateUnitProcesses(
                    mapa?.business_process_list?.organization_unit_id,
                    mapa?.business_process_list?.level,
                    processes,
                    rawMapas
                  )}
                  onChange={handleChangeProcess}
                  selectedValue={mapa?.business_process_list?.name || ""}
                  disabled={!mapa.adding && !mapa.edit}
                />
              </CenterDropdownWrapper>
            </div>

            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <CenterDropdownWrapper
                title="CILJ PROCESA"
                wrapperStyle={{ marginBottom: "0" }}
              >
                <DynamicTextarea
                  onChange={handleChange("process_goal")}
                  value={mapa.process_goal ? mapa.process_goal : ""}
                  readOnly={!mapa.adding && !mapa.edit}
                />
              </CenterDropdownWrapper>
            </div>
            {/* <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <CenterDropdownWrapper
                title="MOGUĆI RIZICI"
                wrapperStyle={{ marginBottom: "0" }}
              >
                <DynamicTextarea
                  onChange={handleChange("potential_risks")}
                  value={mapa.potential_risks ? mapa.potential_risks : ""}
                  readOnly={!mapa.adding && !mapa.edit}
                />
              </CenterDropdownWrapper>
            </div> */}
            <div
              style={{
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  border: "none",
                  marginBottom: "20px",
                }}
              >
                <CenterDropdownWrapper
                  title="Mogući rizici"
                  wrapperStyle={{
                    margin: "0",
                    borderTop:
                      newRisk || activeRisk
                        ? "2px solid var(--mainColor)"
                        : "1px solid var(--mainColor)",
                    borderLeft:
                      newRisk || activeRisk
                        ? "2px solid var(--mainColor)"
                        : "1px solid var(--mainColor)",
                    borderRight:
                      newRisk || activeRisk
                        ? "2px solid var(--mainColor)"
                        : "1px solid var(--mainColor)",
                    borderBottom: "none",
                  }}
                >
                  {mapa.risk_forms && mapa.risk_forms.length > 0 && (
                    <RiskList
                      list={mapa.risk_forms}
                      handleSetActiveProcedure={setActiveProcedure}
                      activeRisk={activeRisk}
                      handleSetEditProcedure={handleSetEditProcedure}
                      handleChangeProcedureName={handleChangeProcedureName}
                      handleSaveProcedure={handleSaveProcedure}
                      handleUpdateProcedure={handleUpdateProcedure}
                      setProcedureToDelete={setProcedureToDelete}
                      mapa={mapa}
                      processes={processes}
                      handleSetEditRisk={handleSetEditRisk}
                      handleChangeRiskName={handleChangeRiskName}
                      handleUpdateRisk={handleUpdateRisk}
                      riskValidationError={riskValidationError}
                      setRiskToDelete={setRiskToDelete}
                      canEdit={canEditMapa}
                    />
                  )}
                </CenterDropdownWrapper>

                {newRisk && (
                  <NewRisk
                    handleChangeNewRiskName={handleChangeNewRiskName}
                    name={newRisk?.name}
                    handleSaveNewRisk={handleSaveNewRisk}
                    newRiskValidationError={newRiskValidationError}
                    processes={processes}
                    mapa={mapa}
                    handleDeleteNewRisk={handleDeleteNewRisk}
                  />
                )}
              </div>
              {canEditMapa && (
                <button
                  disabled={
                    !mapaList?.[mapa.id] || !mapa.business_process_list_id
                  }
                  onClick={handleAddNewRisk}
                  className={
                    !mapaList?.[mapa.id] || !mapa.business_process_list_id
                      ? "add-button add-button-disabled"
                      : "add-button"
                  }
                >
                  <img src="/images/plus.png" />
                  <span>Dodajte rizik</span>
                </button>
              )}
            </div>

            {mapaList && mapaList[mapa.id] && (
              <MapeProcesaAktivnostiList
                canEdit={canEditMapa}
                handleAddNewActivitiItem={handleAddNewActivitiItem}
                activitiesList={mapa.activities}
                handleChangeActivitiName={handleChangeActivitiName}
                handleChangeActivitiDescription={
                  handleChangeActivitiDescription
                }
                newActivity={newActivity}
                handleChangeNewActivity={handleChangeNewActivity}
                handleSaveNewActivity={handleSaveNewActivity}
                handleSetEditActivity={handleSetEditActivity}
                handleSaveActivity={handleSaveActivity}
                handleChangeActivity={handleChangeActivity}
                newActivityValidationErrors={newActivityValidationErrors}
                mapa={mapa}
                handleUpdateActivity={handleUpdateActivity}
                setActivityToDelete={setActivityToDelete}
                handleDeleteNewActivity={handleDeleteNewActivity}
                activeProcedure={activeProcedure}
              />
            )}

            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <CenterDropdownWrapper
                title="KRATAK OPIS PROCESA"
                wrapperStyle={{ marginBottom: "0" }}
              >
                <div className="text-area-wrapper">
                  <p className="text-area-title">ULAZ:</p>
                  <DynamicTextarea
                    style={{ borderBottom: "1px solid var(--mainColor)" }}
                    onChange={handleChange("description_input")}
                    value={mapa.description_input ? mapa.description_input : ""}
                    readOnly={!mapa.adding && !mapa.edit}
                  />
                </div>
                <div className="text-area-wrapper">
                  <p className="text-area-title">AKTIVNOSTI:</p>
                  <DynamicTextarea
                    style={{ borderBottom: "1px solid var(--mainColor)" }}
                    onChange={handleChange("description_action")}
                    value={
                      mapa.description_action ? mapa.description_action : ""
                    }
                    readOnly={!mapa.adding && !mapa.edit}
                  />
                </div>
                <div className="text-area-wrapper">
                  <p
                    className="text-area-title"
                    style={{ borderBottom: "none" }}
                  >
                    IZLAZ:
                  </p>
                  <DynamicTextarea
                    onChange={handleChange("description_output")}
                    value={
                      mapa.description_output ? mapa.description_output : ""
                    }
                    readOnly={!mapa.adding && !mapa.edit}
                  />
                </div>
              </CenterDropdownWrapper>
            </div>
            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "20px",
              }}
            >
              <CenterDropdownWrapper
                title="VEZE SA DRUGIM POSLOVNIM PROCESIMA / PROCEDURAMA"
                wrapperStyle={{ marginBottom: "0" }}
                centerDropdownWrapperChildrenStyle={{ display: "flex" }}
              >
                {mapa?.correlation_to_other_processes && (
                  <button
                    onClick={clearCorrelation}
                    style={{
                      background: "transparent",
                      outline: "none",
                      border: "none",
                      color: "var(--mainColor)",
                      padding: "0 10px",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    x
                  </button>
                )}
                <DropDown
                  list={
                    mapa.business_process_list
                      ? processes.filter(
                          (proc) =>
                            proc.id !== mapa?.business_process_list_id &&
                            !proc.del
                        )
                      : []
                  }
                  isMulti={true}
                  onChange={handleSelectCorellationProcess}
                  selectedValues={parseCorrelations(
                    mapa?.correlation_to_other_processes
                  ).map((n) => ({ value: { name: n }, label: n }))}
                  disabled={!mapa.adding && !mapa.edit}
                />
              </CenterDropdownWrapper>
            </div>
            <div
              style={{
                border:
                  mapa.edit || mapa.adding
                    ? "2px solid var(--mainColor)"
                    : "none",
                marginBottom: "10px",
              }}
            >
              <CenterDropdownWrapper
                title="RESURSI ZA OSTVARIVANJE POSLOVNOG PROCESA"
                wrapperStyle={{ marginBottom: "0" }}
              >
                <DynamicTextarea
                  onChange={handleChange("resources")}
                  value={mapa.resources ? mapa.resources : ""}
                  readOnly={!mapa.adding && !mapa.edit}
                />
              </CenterDropdownWrapper>
            </div>

            {savedEmptyFields && (
              <div
                style={{
                  color: "var(--mainColor)",
                  fontSize: "14px",
                  paddingLeft: "5px",
                  marginTop: "5px",
                }}
              >
                Mapa je sačuvana. Nisu popunjena polja:{" "}
                {savedEmptyFields.join(", ")}.
              </div>
            )}
            {canEditMapa && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <button
                  className="add-poslovni-proces-btn"
                  onClick={handleSubmitMapa}
                >
                  <img alt="" src="/images/save.png" />
                  <span>Sačuvajte mapu procesa</span>
                </button>
                <button
                  className="add-poslovni-proces-btn"
                  onClick={() => setMapaToDelete(mapa)}
                >
                  <img alt="" src="/images/trash.png" />
                  <span>Izbrišite mapu procesa</span>
                </button>
              </div>
            )}

            <div
              style={{
                marginTop: "40px",
              }}
            >
              <div
                style={{
                  border: "none",
                  marginBottom: "20px",
                }}
              >
                <CenterDropdownWrapper
                  title="ŠIFRE I NAZIV PROCEDURA"
                  wrapperStyle={{ margin: "0", borderBottom: "none" }}
                >
                  {mapa.procedures && mapa.procedures.length > 0 && (
                    <ProcedureList
                      canEdit={canEditMapa}
                      proceduresList={mapa.procedures}
                      handleSetActiveProcedure={setActiveProcedure}
                      activeProcedure={activeProcedure}
                      handleSetEditProcedure={handleSetEditProcedure}
                      handleChangeProcedureName={handleChangeProcedureName}
                      handleSaveProcedure={handleSaveProcedure}
                      handleUpdateProcedure={handleUpdateProcedure}
                      setProcedureToDelete={setProcedureToDelete}
                      mapa={mapa}
                      processes={processes}
                    />
                  )}
                </CenterDropdownWrapper>

                {newProcedure && (
                  <NewProcedura
                    handleChangeNewProceduraName={handleChangeNewProceduraName}
                    name={newProcedure?.name}
                    handleSaveNewProcedure={handleSaveNewProcedure}
                    code={newProcedure?.code}
                    handleDeleteNewProcedure={handleDeleteNewProcedure}
                    newProcedureValidationErrors={newProcedureValidationErrors}
                    setProcedureToDelete={setProcedureToDelete}
                    newProcedure={newProcedure}
                    processes={processes}
                    mapa={mapa}
                  />
                )}
              </div>
              {canEditMapa && (
                <button
                  disabled={
                    !mapaList?.[mapa.id] ||
                    newProcedure ||
                    !mapa.business_process_list_id
                  }
                  onClick={handleAddNewProcedure}
                  className={
                    newProcedure ||
                    !mapaList?.[mapa?.id] ||
                    !mapa.business_process_list_id
                      ? "add-button add-button-disabled"
                      : "add-button"
                  }
                >
                  <span style={{ marginRight: "5px" }}>+</span>
                  Dodajte proceduru
                </button>
              )}
            </div>

            <div
              style={{
                border: "none",
                margin: "20px 0",
              }}
            >
              <PoslovniProcessOwnerTable
                employees={designations}
                preparedBy={mapa?.prepared_by}
                controlledBy={mapa?.controlled_by}
                approvedBy={mapa?.approved_by}
                preparedAt={mapa?.prepared_at}
                controlledAt={mapa?.controlled_at}
                approvedAt={mapa?.approved_at}
                onChangePreparedBy={handleChangePreparedBy}
                onChangeControlledBy={handleChangeControlledBy}
                onChangeApprovedBy={handleChangeApprovedBy}
                onChangePreparedAt={handleChangePreparedAt}
                onChangeControlledAt={handleChangeControlledAt}
                onChangeApprovedAt={handleChangeApprovedAt}
                disabled={!mapa.adding && !mapa.edit}
              />
            </div>

            {mapa.procedures && activeProcedure && (
              <>
                <ProcedureDocumentation
                  procedure={activeProcedure}
                  mapa={mapa}
                  employees={designations}
                  designations={designationsList}
                  organizationUnits={organization_units}
                  disabled={!mapa.adding && !mapa.edit}
                  onChangeProcedureField={handleChangeProcedureField}
                  onChangeResponsibilityRow={handleChangeResponsibilityRow}
                  onAddResponsibilityRow={handleAddResponsibilityRow}
                  onRemoveResponsibilityRow={handleRemoveResponsibilityRow}
                  onChangeProcedurePreparedBy={handleChangeProcedurePreparedBy}
                  onChangeProcedureControlledBy={handleChangeProcedureControlledBy}
                  onChangeProcedureApprovedBy={handleChangeProcedureApprovedBy}
                  onChangeProcedurePreparedAt={handleChangeProcedurePreparedAt}
                  onChangeProcedureControlledAt={handleChangeProcedureControlledAt}
                  onChangeProcedureApprovedAt={handleChangeProcedureApprovedAt}
                />
                <div
                  style={{
                    width: "70%",
                    color: "var(--mainColor)",
                    textAlign: "center",
                    margin: "50px auto 30px auto",
                  }}
                >
                  DOKUMENTACIJA O SISTEMU (VERTIKALNI PREGLED) - PROCEDURE -
                  <span
                    style={{
                      marginLeft: "5px",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    {activeProcedure?.name || ""}
                  </span>
                </div>
                <MapeDokumentacija
                  canEdit={canEditMapa}
                  list={activeProcedure?.activities}
                  designations={designationsList}
                  handleChangeResponsibleDesignations={
                    handleChangeResponsibleDesignations
                  }
                  handleSelectDueDate={handleSelectDueDate}
                  handleChangeDynamicDescription={
                    handleChangeDynamicDescription
                  }
                  handleChangeDocumentPath={handleChangeDocumentPath}
                  handleSetEditProcedureRow={handleSetEditProcedureRow}
                  handleUpdateProcedureRow={handleUpdateProcedureRow}
                  handleChangeProcedureRow={handleChangeProcedureRow}
                  handleSelectProceduraRowResponsibles={
                    handleSelectProceduraRowResponsibles
                  }
                  handleChangeProcedureRowDueDate={
                    handleChangeProcedureRowDueDate
                  }
                  handleChangeNewMapaDocument={handleChangeNewMapaDocument}
                  handleAddNewMapaDocumentList={handleAddNewMapaDocumentList}
                  handleRejectMapaDukument={handleRejectMapaDukument}
                  handleAddMapaDocumentName={handleAddMapaDocumentName}
                  handleRemoveMapaDocument={handleRemoveMapaDocument}
                  handleUploadMapaDocument={handleUploadMapaDocument}
                  setActivityToDelete={setActivityToDelete}
                  mapa={mapa}
                  validationsErrors={oldProcedureRowValidationsError}
                >
                  {newProcedureRow && (
                    <NewProcedureRow
                      name={newProcedureRow?.name}
                      designations={designationsList}
                      description={newProcedureRow?.description}
                      handleChangeNewProcedureRow={handleChangeNewProcedureRow}
                      handleSelectDueDate={handleSelectDueDate}
                      due_date={newProcedureRow?.due_date}
                      handleSelectNewProcedureResponsibleDesignations={
                        handleSelectNewProcedureResponsibleDesignations
                      }
                      responsibles={newProcedureRow?.activities_designations}
                      handleAddLink={handleAddLink}
                      handleChangeLink={handleChangeLink}
                      links={newProcedureRow?.documents}
                      handleSaveNewProcedureRow={handleSaveNewProcedureRow}
                      handleDeleteNewProcedureRow={handleDeleteNewProcedureRow}
                      newProcedureRowValidationsError={
                        newProcedureRowValidationsError
                      }
                      handleAddNewMapaDocumentList={handleAddNewMapaDocumentList}
                      handleRejectMapaDukument={handleRejectMapaDukument}
                      handleChangeNewMapaDocument={handleChangeNewMapaDocument}
                      handleSaveNewMapaDocument={handleSaveNewMapaDocument}
                      handleAddMapaDocumentName={handleAddMapaDocumentName}
                      handleRemoveMapaDocument={handleRemoveMapaDocument}
                      handleUploadMapaDocument={handleUploadMapaDocument}
                      setActivityToDelete={setActivityToDelete}
                      newProcedureRow={newProcedureRow}
                    />
                  )}
                </MapeDokumentacija>
                {canEditMapa && (
                  <button
                    className={
                      newProcedureRow
                        ? "add-button add-button-disabled"
                        : "add-button"
                    }
                    disabled={newProcedureRow}
                    onClick={handleAddNewProcedureRow}
                    style={{ padding: "20px 0" }}
                  >
                    <span style={{ marginRight: "5px" }}>+</span>
                    Dodajte red
                  </button>
                )}
              </>
            )}
          </div>
        )}
        {mapaToDelete && (
          <div className="loading">
            <DeleteMapaPopup
              setItemToDelete={setMapaToDelete}
              loading={loading}
              handleItemDelete={HandleDeleteMapa}
            />
          </div>
        )}
        {activityToDelete && (
          <div className="loading">
            <DeleteMapaPopup
              setItemToDelete={setActivityToDelete}
              loading={loading}
              handleItemDelete={handleDeleteActivity}
            />
          </div>
        )}
        {procedureToDelete && (
          <div className="loading">
            <DeleteMapaPopup
              setItemToDelete={setProcedureToDelete}
              loading={loading}
              handleItemDelete={handleDeleteProcedure}
            />
          </div>
        )}
        {riskToDelete && (
          <div className="loading">
            <DeleteMapaPopup
              setItemToDelete={setRiskToDelete}
              loading={loading}
              handleItemDelete={handleDeleteRisk}
            />
          </div>
        )}
        {mapa && (
          <div style={{ display: "none" }}>
            {/* otvorena procedura se štampa sa kompletnom dokumentacijom */}
            <MapaProcesaPrint
              ref={componentRef}
              mapa={mapa}
              activeProcedure={activeProcedure}
            />
          </div>
        )}
        {showVersionHistory && mapa?.id && (
          <VersionHistory
            entityType="process_map"
            entityId={mapa.id}
            onClose={() => setShowVersionHistory(false)}
          />
        )}
        <Loading isLoading={loading} />
      </div>
    </>
  );
}




